'use client';
import {useNavigation} from '@/contexts/NavigationContext';
import {useEffect, useCallback} from 'react';
import {isEqual} from "@/lib/utils";


interface NavigationSetterProps {
    links: { title: string; id: string; href?: string; hasWow?: boolean }[];
    ticketRef?: string;
    showSocialLinks?: boolean;
}

export default function NavigationSetter({
                                             links,
                                             ticketRef = 'atc-website-nav',
                                             showSocialLinks = true
                                         }: NavigationSetterProps) {
    const {
        sections,
        ticketRef: currentTicketRef,
        showSocialLinks: currentShowSocialLinks,
        setNavigation
    } = useNavigation();

    useEffect(() => {
        if (!isEqual(links, sections) ||
            ticketRef !== currentTicketRef ||
            showSocialLinks !== currentShowSocialLinks) {
            setNavigation(links, ticketRef, showSocialLinks);
        }
    }, [links, ticketRef, showSocialLinks, sections, currentTicketRef, currentShowSocialLinks, setNavigation]);

    return null;
}
